import React from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

function Diler({ handleInputChange, inputAnswer, inputRef }) {
  const handleKeyPress = (key) => {
    let newValue = inputAnswer || "";
    let cursorPos = inputRef.current?.selectionStart || newValue.length;
    inputRef.current.focus();

    if (key === ".") {
      if (newValue.includes(".")) return;
      newValue = newValue.slice(0, cursorPos) + key + newValue.slice(cursorPos);
      cursorPos++;
    } else if (key === "-") {
      if (newValue.startsWith("-")) {
        newValue = newValue.slice(1);
        cursorPos = Math.max(0, cursorPos - 1);
      } else {
        newValue = "-" + newValue;
        cursorPos++;
      }
    } else if (key === "backspace") {
      if (cursorPos > 0) {
        newValue =
          newValue.slice(0, cursorPos - 1) + newValue.slice(cursorPos);
        cursorPos--;
      }
    } else if (key === "←") {
      if (cursorPos > 0) cursorPos--;
    } else if (key === "→") {
      if (cursorPos < newValue.length) cursorPos++;
    } else if (key === "clear") {
      newValue = "";
      cursorPos = 0;
    } else {
      newValue = newValue.slice(0, cursorPos) + key + newValue.slice(cursorPos);
      cursorPos++;
    }

    handleInputChange({ target: { value: newValue } });

    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.selectionStart = cursorPos;
        inputRef.current.selectionEnd = cursorPos;
      }
    }, 0);
  };

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      spacing={1}
      style={{
        padding: 10,
        marginBottom: 20,
        backgroundColor: "#e5e1e1ff",
        width: "150px",
        borderRadius: "10px",
      }}
    >
      {/* Backspace button full width */}
      <Grid item xs={12} style={{ width: "80%",color: "black",border: "1px solid black" }}>
        <Button
          fullWidth
          // variant="contained"
          color="black"
          style={{ fontSize: 13 }}
          onClick={() => handleKeyPress("backspace")}
        >
          Backspace
        </Button>
      </Grid>

      {/* Number grid */}
      {[["7", "8", "9"], ["4", "5", "6"], ["1", "2", "3"], ["0", ".", "-"]].map(
        (row, rowIndex) => (
          <Grid container item key={rowIndex} justifyContent="center" spacing={1}>
            {row.map((key, idx) => (
              <Grid item key={idx}>
                <Button
                  // variant="outlined"
                  style={{ minWidth: 30, minHeight: 30, fontSize: 14,color: "black",border: "1px solid black" }}
                  onClick={() => handleKeyPress(key)}
                >
                  {key}
                </Button>
              </Grid>
            ))}
          </Grid>
        )
      )}

      {/* Arrow buttons */}
      <Grid container item justifyContent="center" spacing={1}>
        <Grid item>
          <Button
            // variant="contained"
            style={{ minWidth: 40, minHeight: 30,color: "black",border: "1px solid black", fontSize: 13 }}
            onClick={() => handleKeyPress("←")}
          >
            ←
          </Button>
        </Grid>
        <Grid item>
          <Button
            // variant="contained"
            style={{ minWidth: 40, minHeight: 30,color: "black",border: "1px solid black", fontSize: 13  }}
            onClick={() => handleKeyPress("→")}
          >
            →
          </Button>
        </Grid>
      </Grid>

      {/* Clear All button full width */}
      <Grid item xs={12} style={{ width: "80%",color: "black",border: "1px solid black" }}>
        <Button
          fullWidth
          color="black"
          // variant="contained"
          onClick={() => handleKeyPress("clear")}
          style={{ fontSize: 13 }}
        >
          Clear All
        </Button>
      </Grid>
    </Grid>
  );
}

export default Diler;
